import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  AlertBasicModalOverlay,
  AlertBasicContainer,
  AlertTitle,
  AlertDescription,
  ButtonArea,
  CancelButton,
  OkButton,
} from "./style";

interface AlertBasicProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCancel: () => void;
  onOk: () => void;
  title?: ReactNode;
  description?: ReactNode;
  okText?: ReactNode;
  cancelText?: ReactNode;
  isOkLoading?: boolean;
  children?: ReactNode;
}

const AlertBasic = ({
  open,
  onOpenChange,
  onCancel,
  onOk,
  title,
  description,
  okText,
  cancelText,
  isOkLoading,
  children,
}: AlertBasicProps) => {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <AlertBasicModalOverlay>
      <AlertBasicContainer>
        {title && <AlertTitle>{title}</AlertTitle>}
        {description && <AlertDescription>{description}</AlertDescription>}
        {children}
        <ButtonArea>
          <CancelButton onClick={onCancel}>{cancelText ?? t("common:cancel")}</CancelButton>
          <OkButton onClick={onOk} disabled={isOkLoading}>
            {isOkLoading ? t("common:loading") : okText ?? t("common:ok")}
          </OkButton>
        </ButtonArea>
      </AlertBasicContainer>
    </AlertBasicModalOverlay>
  );
};

export default AlertBasic; 